export const getLocalStorageValue = (name: string, defaultValue: any): any => {
	return typeof window === 'undefined' ? defaultValue : localStorage.getItem(name) || defaultValue;
};

export const setLocalStorageValue = (name: string, value: any) => {
	if (typeof window !== 'undefined') {
		localStorage.setItem(name, value);
	}
};
